<template>
  <div class="content_div">
    <el-card>
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="店铺名称">
          <el-input clearable class="input_class" v-model="query.shopName" auto-complete="off" placeholder="请输入店铺名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value="" />
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
        <el-button type="success" @click="btnInsert()">新增</el-button>
      </el-form>

      <el-table
        v-loading="loading"
        :data="dataList"
        border
      >
        <el-table-column label="店铺ID" align="center" prop="id" width="80" />
        <el-table-column label="店铺名称" align="center" prop="shopName" min-width="150" />
        <el-table-column label="营业执照" align="center" width="120">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.businessLicense"
              style="width: 60px; height: 60px"
              :src="scope.row.businessLicense"
              :preview-src-list="[scope.row.businessLicense]"
              fit="cover">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="门店照片" align="center" width="120">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.storePhoto"
              style="width: 60px; height: 60px"
              :src="scope.row.storePhoto"
              :preview-src-list="[scope.row.storePhoto]"
              fit="cover">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="店铺地址" align="center" prop="address" min-width="200" show-overflow-tooltip />
        <el-table-column label="店铺介绍" align="center" prop="introduction" min-width="200" show-overflow-tooltip />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="remark" min-width="150" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="btnUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="isShowDialogFlag" width="800px" :close-on-click-modal="false">
      <el-form ref="form" :model="data" :rules="rules" label-width="120px">
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="data.shopName" placeholder="请输入店铺名称" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        
        <el-form-item label="营业执照">
          <el-upload
            class="avatar-uploader"
            action="/api/upload"
            :show-file-list="false"
            :on-success="handleBusinessLicenseSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="data.businessLicense" :src="data.businessLicense" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸：800x600像素，支持jpg、png格式</div>
        </el-form-item>

        <el-form-item label="门店照片">
          <el-upload
            class="avatar-uploader"
            action="/api/upload"
            :show-file-list="false"
            :on-success="handleStorePhotoSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="data.storePhoto" :src="data.storePhoto" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸：800x600像素，支持jpg、png格式</div>
        </el-form-item>

        <el-form-item label="店铺地址" prop="address">
          <el-input v-model="data.address" placeholder="请输入店铺地址" maxlength="255" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="店铺介绍">
          <el-input 
            v-model="data.introduction" 
            type="textarea" 
            :rows="4"
            placeholder="请输入店铺介绍" 
            maxlength="2000" 
            show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="data.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input 
            v-model="data.remark" 
            type="textarea" 
            :rows="3"
            placeholder="请输入备注" 
            maxlength="500" 
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowDialogFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShopPage, insertShop, updateShop, deleteShop } from '@/api/ordering/shop'

export default {
  name: 'ShopManage',
  async created() {
    await this.load()
  },
  data() {
    return {
      loading: true,
      total: 0,
      dataList: [],
      query: {
        currentPage: 1,
        pageSize: 10,
        shopName: undefined,
        status: undefined
      },
      isShowDialogFlag: false,
      dialogTitle: '',
      data: {
        id: null,
        shopName: null,
        businessLicense: null,
        storePhoto: null,
        address: null,
        introduction: null,
        status: 1,
        remark: null
      },
      rules: {
        shopName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入店铺地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async load() {
      this.loading = true
      let res = await getShopPage(this.query)
      this.dataList = res.records || []
      this.total = res.total || 0
      this.loading = false
    },
    
    btnInsert() {
      this.dialogTitle = '新增店铺'
      this.resetForm()
      this.isShowDialogFlag = true
    },
    
    btnUpdate(row) {
      this.dialogTitle = '编辑店铺'
      this.data = { ...row }
      this.isShowDialogFlag = true
    },
    
    async btnDelete(id) {
      this.$confirm('确认删除该店铺吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await deleteShop(id)
        if (res.code === 200) {
          this.$message.success('删除成功')
          await this.load()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      }).catch(() => {})
    },
    
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res
          if (this.data.id) {
            res = await updateShop(this.data)
          } else {
            res = await insertShop(this.data)
          }
          
          if (res.code === 200) {
            this.$message.success(this.data.id ? '修改成功' : '新增成功')
            this.isShowDialogFlag = false
            await this.load()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        }
      })
    },
    
    resetForm() {
      this.data = {
        id: null,
        shopName: null,
        businessLicense: null,
        storePhoto: null,
        address: null,
        introduction: null,
        status: 1,
        remark: null
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    
    handleBusinessLicenseSuccess(response, file) {
      // 这里需要根据实际的上传接口返回格式调整
      this.data.businessLicense = response.url || response.data
      this.$message.success('上传成功')
    },
    
    handleStorePhotoSuccess(response, file) {
      // 这里需要根据实际的上传接口返回格式调整
      this.data.storePhoto = response.url || response.data
      this.$message.success('上传成功')
    },
    
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    
    handleSizeChange(val) {
      this.query.pageSize = val
      this.load()
    },
    
    handleCurrentChange(val) {
      this.query.currentPage = val
      this.load()
    }
  }
}
</script>

<style scoped>
.content_div {
  padding: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
</style>
